import {EmptyResult, ProjectDataIndex} from '../types';
import {useDelete, useGet, usePost} from '../useHttpHooks';
import toQuery from '../../lib/toQuery.ts';

// MixiplyCore.Domain.Entities.TranslationMode
export enum TranslationMode {
    Text = 0,
    // What a vibe-coded tab is and how to use it, with the words on screen.
    Guide = 1
}

// The source of a translation, as the panel works it out for the page it is on.
export type TranslationSource = {
    text: string | null;
    mixId: string | null;
    dataIndex: ProjectDataIndex | null;
    contentPackageId: string | null;
};

export type SavedTranslationRow = {
    id: string;
    pageKey: string;
    title: string;
    language: string;
    mode: TranslationMode;
    mixId: string | null;
    dataIndex: ProjectDataIndex | null;
    createdOnUtc: string;
    // Only worked out for the page you are on; null in the list of everything.
    outOfDate: boolean | null;
};

export type SavedTranslationDetail = {
    id: string;
    title: string;
    language: string;
    mode: TranslationMode;
    createdOnUtc: string;
    output: string;
};

export const useTranslationsForPage = () =>
    usePost<TranslationSource & {pageKey: string}, SavedTranslationRow[]>(
        `/api/assistant/translations/for-page`,
        {errorMessage: 'POST api/assistant/translations/for-page failed'}
    );

export const useSavedTranslations = (skip = 0, take = 50) =>
    useGet<SavedTranslationRow[]>(
        `/api/assistant/translations?${toQuery({skip, take})}`,
        {errorMessage: 'GET api/assistant/translations failed'}
    );

export const useSavedTranslation = (id: string) =>
    useGet<SavedTranslationDetail>(
        `/api/assistant/translations/${encodeURIComponent(id)}`,
        {errorMessage: 'GET api/assistant/translations/{id} failed'}
    );

export const useDeleteSavedTranslation = (id: string) =>
    useDelete<EmptyResult>(
        `/api/assistant/translations/${encodeURIComponent(id)}`,
        {errorMessage: 'DELETE api/assistant/translations/{id} failed'}
    );
